<template>
  <v-layout row wrap pa-3>
    <v-flex xs12 wrap>
      <v-layout column main-section>
        <v-flex pt-3>
          <v-card-title>
            <!-- <h3 class="halfwhite-text">
                {{ $store.getters.getHeadingForBalanceBlock }}
              </h3> -->
            <v-icon>mdi-account-outline</v-icon>
            <h4 class="headline halfwhite-text ml-2">Manage Profile</h4>
          </v-card-title>
          <v-flex mx-3 mt-3>
            <ProfileInfo></ProfileInfo>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import ProfileInfo from "@/components/ProfileInfo";

export default {
  name: "ProfileView",
  components: { ProfileInfo },
};
</script>

